import { createBrowserHistory } from 'history';

const createHistory = typeof document !== undefined ? createBrowserHistory : () => { };

const history = createHistory();

export default history;